import type { PasswordHelperRule } from '@sunwebgroup/uds-ui/fields/password-field'
import { passwordValidations } from './passwordValidations'

export type PasswordRuleLabels = Record<keyof typeof passwordValidations, string>

function toRuleStatus(isSatisfied: boolean): PasswordHelperRule['status'] {
  return isSatisfied ? 'satisfied' : 'unsatisfied'
}

export function buildPasswordHelperRules(password: string, labels: PasswordRuleLabels): PasswordHelperRule[][] {
  return [
    [
      { text: labels.minLength, status: toRuleStatus(passwordValidations.minLength(password)) },
      { text: labels.number, status: toRuleStatus(passwordValidations.number(password)) },
    ],
    [
      { text: labels.lowerCase, status: toRuleStatus(passwordValidations.lowerCase(password)) },
      { text: labels.upperCase, status: toRuleStatus(passwordValidations.upperCase(password)) },
    ],
  ]
}
